import React, { useState } from "react";
import PropTypes from "prop-types";
import { useIntl } from "react-intl";
import { Dialog } from "@material-ui/core";
import ThumbDown from "@material-ui/icons/ThumbDown";
import useSWR from "swr";

import { usePermission } from "../../../../hooks";
import { ActionButton } from "../../../../components";
import permissions from "../../../../_common/permissions";
import { TIPO_FUNCIONALIDADE } from "../../../../_common/constantes";
import ModalEnriquecer from "./ModalEnriquecer";
import { cpf } from "../../../../components/TextMaskCpfCnpj";
import { createSnackbar } from "../../../../_common";

const LIMITE_LEADS = 100;

Enriquecer.propTypes = {
  callback: PropTypes.func,
  children: PropTypes.func,
  claim: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
  leads: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      nome: PropTypes.string,
      cpfCnpj: PropTypes.string,
    })
  ),
};

function Enriquecer({ callback = x => x, children, leads = [], ...props }) {
  const intl = useIntl();
  const permissaoSearching = usePermission(permissions.SEARCHING);
  const [modalOpen, setModalOpen] = useState(false);
  const [listaLeadsInvalidos, setListaLeadsInvalidos] = useState([]);
  const [listaLeadsValidos, setListaLeadsValidos] = useState([]);

  const { data: possuiSearching } = useSWR(
    `/api/pipeline/funcionalidadeplanoempresa/temfuncionalidade?tipofuncionalidade=${
      TIPO_FUNCIONALIDADE.SEARCHING
    }&validartrial=false`
  );

  if (!possuiSearching || !permissaoSearching) return null;

  const validarLeads = () => {
    const leadsValidos = [];
    const leadsInvalidos = [];
    leads.forEach(lead => {
      if (lead?.cpfCnpj && lead?.cpfCnpj?.length > cpf.length - 3) {
        leadsValidos.push(lead);
      } else {
        leadsInvalidos.push(lead);
      }
    });
    return { leadsValidos, leadsInvalidos };
  };

  const close = response => {
    setModalOpen(false);
    callback(response);
  };

  const abrirModal = () => {
    if (leads.length > LIMITE_LEADS) {
      createSnackbar(intl.formatMessage({ defaultMessage: "Selecione até 100 leads para realizar o enriquecimento" }));
      return;
    }

    const { leadsValidos, leadsInvalidos } = validarLeads();

    if (leadsValidos.length === 0) {
      createSnackbar(
        intl.formatMessage({
          defaultMessage: "Selecione pelo menos um lead com CNPJ válido para realizar o enriquecimento",
        })
      );
      return;
    }

    setListaLeadsValidos(leadsValidos);
    setListaLeadsInvalidos(leadsInvalidos);
    setModalOpen(true);
  };

  return (
    <>
      {children ? (
        children({ setModalOpen })
      ) : (
        <ActionButton
          id="btn-enriquecer-leads-massa"
          type="menu"
          label={intl.formatMessage({
            defaultMessage: "Enriquecer",
          })}
          icon={<ThumbDown />}
          onClick={abrirModal}
          leads={leads}
          {...props}
        />
      )}
      <Dialog maxWidth="sm" fullWidth open={modalOpen} onClose={() => close(false)}>
        <ModalEnriquecer
          leadsValidos={listaLeadsValidos}
          leadsInvalidos={listaLeadsInvalidos}
          {...props}
          callback={close}
        />
      </Dialog>
    </>
  );
}

export default Enriquecer;
